<div class="contact_block">
<div class="contact_head">FOLGE UNS</div>
  <div class="contact_icons">
    <img class="social_icon" src="assets/iconmonstr-instagram-11.svg"
         (click)="navigation.instagram()">
    <img class="social_icon" src="assets/iconmonstr-facebook-4.svg"
         (click)="navigation.facebook()">
    <img class="social_icon" src="assets/iconmonstr-youtube-6.svg"
         (click)="navigation.youtube()">
    <img class="social_icon" src="assets/iconmonstr-spotify-1.svg"
         (click)="navigation.spotify()">
    <img class="social_icon" src="assets/iconmonstr-email-2.svg"
         (click)="navigation.email()">
  </div>

  <div class="contact_text" (click)="navigation.email()">
    band<span style="font-family: Roboto">@</span>rooftopradio.de
  </div>

  <div class="contact_text"><span style="font-family: Roboto">@</span> 2021 ROOFTOP RADIO | GÖRLITZ | <span (click)="navigation.impressum()" style="cursor: pointer"> IMPRESSUM</span></div>

</div>
